export const terms = {
  "header": {
    "badge": "Νομικές πληροφορίες",
    "title": "Όροι Χρήσης"
  },
  "content": {
    "intro": "Καλώς ήρθατε στο DONKEY TRAVEL. Αυτοί οι όροι χρήσης διέπουν την πρόσβαση και τη χρήση της πλατφόρμας ανταλλαγής κατοικιών μας. Χρησιμοποιώντας τις υπηρεσίες μας, αποδέχεστε πλήρως αυτούς τους όρους.",
    "eligibility": {
      "title": "1. Επιλεξιμότητα και Εγγραφή",
      "text": "Η πρόσβαση στο κλαμπ DONKEY TRAVEL προορίζεται αυστηρά για οικοδεσπότες με ενεργή διαφήμιση σε αναγνωρισμένες πλατφόρμες (όπως η Airbnb) με ελάχιστη συνολική βαθμολογία 4,5 στα 5. Οποιαδήποτε παραποίηση αυτών των κριτηρίων θα έχει ως αποτέλεσμα την άμεση διαγραφή του λογαριασμού χωρίς επιστροφή χρημάτων για τη συνδρομή."
    },
    "subscription": {
      "title": "2. Συνδρομή και πληρωμές",
      "text": "Η πλήρης χρήση της πλατφόρμας απαιτεί συνδρομή σε ένα από τα πακέτα μας (Μηνιαία, Ετήσια ή Club+). Οι πληρωμές είναι ασφαλείς και επεξεργάζονται από τρίτους παρόχους. Η συνδρομή είναι σιωπηρά ανανεώσιμη εκτός εάν ακυρωθεί από τον χρήστη."
    },
    "exchanges": {
      "title": "3. Πώς λειτουργούν οι ανταλλαγές",
      "text": "Οι ανταλλαγές εντός του συλλόγου βασίζονται στην εμπιστοσύνη και τον αμοιβαίο σεβασμό. Οι συμφωνίες ανταλλαγής γίνονται απευθείας μεταξύ των μελών μέσω των εσωτερικών μας μηνυμάτων. Μεταξύ των δύο μερών συνάπτεται μια ηθική και, κατά περίπτωση, νομική σύμβαση ανταλλαγής."
    },
    "responsibilities": {
      "title": "4. Δεσμεύσεις και Ευθύνες",
      "text": "Κάθε μέλος αναλαμβάνει να παρουσιάσει τη διαμονή του με διαφανή τρόπο, με πρόσφατες φωτογραφίες και ακριβείς περιγραφές. Το μέλος υποδοχής φροντίζει για την άψογη υγιεινή του χώρου. Το μέλος που επισκέπτεται αναλαμβάνει να σέβεται σχολαστικά το κατάλυμα και τους εσωτερικούς του κανονισμούς. Η DONKEY TRAVEL λειτουργεί ως διευκολυντής και δεν είναι συμβαλλόμενο μέρος στις συμβάσεις ανταλλαγής μεταξύ των μελών. Δεν αναλαμβάνουμε καμία ευθύνη για ζημιές, διαφορές ή ακυρώσεις της τελευταίας στιγμής, αν και μπορούμε να παρέμβουμε στη διαμεσολάβηση."
    },
    "termination": {
      "title": "5. Αναστολή και τερματισμός",
      "text": "Η DONKEY TRAVEL διατηρεί το δικαίωμα να αναστείλει ή να απαγορεύσει μονομερώς οποιοδήποτε μέλος δεν σέβεται τους κανόνες καλής συμπεριφοράς της κοινότητας, συσσωρεύει άσχημα σχόλια ή παραβιάζει αυτούς τους όρους."
    },
    "contact": {
      "title": "6. Εφαρμοστέο δίκαιο και διαφορές",
      "text": "Οι όροι αυτοί διέπονται από το γαλλικό δίκαιο. Σε περίπτωση διαφωνίας, τα μέρη αναλαμβάνουν την υποχρέωση να αναζητήσουν φιλική λύση πριν από κάθε δικαστική ενέργεια ενώπιον των αρμόδιων δικαστηρίων. Για οποιεσδήποτε ερωτήσεις, επικοινωνήστε μαζί μας στο legal@donkey.travel."
    }
  }
};
